import { env } from "@/env"
import { Http } from "@repo/http"
import { getSiteUrl } from "@repo/shared"
import { deleteCookie } from "cookies-next"

import { showAuthErrorModal } from "./modal"

const http = new Http()

http.setDefaultConfig({
	baseURL: env.NEXT_PUBLIC_API_HOST_EN ?? "",
	urlTokenName: "auth_token",
	timeout: 10000,
	getLang: async () => {
		if (typeof window === "undefined") {
			const { cookies } = await import("next/headers")
			const cookieStore = await cookies()
			return cookieStore.get("locale")?.value ?? "en"
		}
		return "en"
	},
	getToken: async () => {
		if (typeof window === "undefined") {
			const { cookies } = await import("next/headers")
			const cookieStore = await cookies()
			const key = env.NEXT_PUBLIC_AUTH_TOKEN_KEY
			return (key ? cookieStore.get(key)?.value : undefined) ?? ""
		}
		return ""
	},
	log: { enable: false },
	successCode: [0],
})
http.addErrorInterceptor(async (error) => {
	const errorData = error.toJSON()
	if (errorData.statusCode === 200 && (errorData.code === 10003 || errorData.code === 20003)) {
		if (typeof window !== "undefined") {
			await showAuthErrorModal(errorData.message ?? "Login Invalidated", () => {
				deleteCookie(env.NEXT_PUBLIC_AUTH_TOKEN_KEY ?? "", {
					domain: ".metal.com",
					path: "/",
				})
				const loginUrl = `${getSiteUrl("user")}/login?url=${encodeURIComponent(window.location.href)}&clearAuth=true`
				window.location.replace(loginUrl)
			})
			return false
		}
		return true
	}
	return true
})
export default http
